"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const order_fragment_1 = __importDefault(require("../fragments/order.fragment"));
const mutation = (0, client_1.gql) `
  mutation breakApartOrder($orderId: String!) {
    breakApartOrder(orderId: $orderId) {
      _id
      event {
        _id
        isMultipleDays
        name
        subtitle
        performances {
          schedule {
            doorsAt
            startsAt
          }
        }
        venue {
          _id
          name
          address {
            state
            city
            timezone
          }
        }
        organization {
          orgName
          ticketFormat
        }
      }
      state
      type
      ...OrderTickets
      ...OrderUpgrades
    }
  }
  ${order_fragment_1.default.fragments.tickets}
  ${order_fragment_1.default.fragments.upgrades}
`;
exports.default = mutation;
//# sourceMappingURL=breakApartOrder.js.map